/**
 * StickyStepNav — floating chapter pill bar at top of the scrolling document.
 *
 * Replaces the old persistent tab strip + globe-row chrome as the user's
 * "where am I in the chain" affordance. Clicking jumps to that step + scrolls
 * the script into view. Sticky-top so it stays oriented during long scroll.
 */
export default function StickyStepNav({ steps, currentStep, onStep, era }) {
  return (
    <div
      className="sticky top-2 z-30 flex justify-center pointer-events-none"
      data-testid="sticky-step-nav"
    >
      <div
        className="pointer-events-auto inline-flex items-center gap-1 px-2 py-1.5 rounded-full backdrop-blur-md"
        style={{
          background: 'rgba(10,10,10,0.78)',
          border: `1px solid ${era.primary}33`,
          boxShadow: `0 6px 24px -8px ${era.primary}55`,
        }}
      >
        {steps.map((s, i) => {
          const active = i === currentStep;
          return (
            <button
              key={s.key}
              data-testid={`step-pill-${s.key}`}
              onClick={() => onStep(i)}
              className="px-2.5 py-1 rounded-full font-hud text-[9px] tracking-widest transition-all"
              style={{
                color: active ? era.primary : 'rgba(255,255,255,0.6)',
                background: active ? `${era.primary}1a` : 'transparent',
                border: `1px solid ${active ? `${era.primary}55` : 'transparent'}`,
              }}
            >
              {i + 1}. {s.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
